import { render, staticRenderFns } from "./edit-receipts.vue?vue&type=template&id=2451d15b&scoped=true"
import script from "./edit-receipts.vue?vue&type=script&lang=js"
export * from "./edit-receipts.vue?vue&type=script&lang=js"
import style0 from "./edit-receipts.vue?vue&type=style&index=0&id=2451d15b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2451d15b",
  null
  
)

export default component.exports